import { ITextBuilder } from "../../Global/Base/Builders/ITextBuilder";

export interface JSONSRVException {
    Message: string;
    Source: string;
    Detail: string;
    ExceptionType: string;
    LogExceptionID: string;
    ExceptionDetails: any;
    StackTrace: string;
}

export interface IDataValidationError {
    attributeNames?: string[];
    linkedAttributes?: boolean;
    errorMessage: string;
}

export interface IComponentValidationError {
    componentNames?: string[];
    invalidValue?: ITextBuilder;
    errorMessage: string;
}

export enum ValidationErrorType {
    dataError, // chyba dat v objektu (serverova chyba)
    inputError, // chyba uzivatelskeho vstupu (uzivatel zadal neplatnou hodnotu)
    requiredError, // chyba povinneho pole (uzivatel nevyplnil povinne pole)
    recommendedError, // chyba doporuceneho pole (uzivatel nevyplnil doporucene pole)
    postponedError, // chyba povinně odloženého pole (uživatel nevyplnil povinně odložené pole)
}

export interface IValidationError extends IDataValidationError, IComponentValidationError {
    type: ValidationErrorType;
    keepOnAttributeChange?: boolean;
}
